// 运营管理
export default [
  {
    path: '/softwareVersion/deviceVersion',
    name: 'deviceVersion',
    meta: {
      title: '设备版本管理'
    },
    component: () => import('@/views/softwareVersion/deviceVersion.vue')
  }
]
